import { render, staticRenderFns } from "./ScheduledTournamentsCalendarApp.vue?vue&type=template&id=7d85ade7&"
import script from "./ScheduledTournamentsCalendarApp.vue?vue&type=script&lang=js&"
export * from "./ScheduledTournamentsCalendarApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports